import React from 'react';
import { Link } from 'react-router-dom';

const AdminNavbar = ({ activeSection, setActiveSection, user, onLogout }) => {
    const sections = [
        { id: 'hero', name: 'Hero Section', icon: '🏠' },
        { id: 'about', name: 'About', icon: '👤' },
        { id: 'photography', name: 'Photography', icon: '📸' },
        { id: 'yoga', name: 'Yoga', icon: '🧘' },
        { id: 'art', name: 'Art', icon: '🎨' }
    ];

    return (
        <nav className="bg-white shadow-lg border-b">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between h-16">
                    <div className="flex items-center">
                        <Link to="/" className="text-xl font-bold text-sage-600 mr-8">
                            Savana Ashlea - Admin
                        </Link>

                        <div className="hidden md:flex space-x-1">
                            {sections.map((section) => (
                                <button
                                    key={section.id}
                                    onClick={() => setActiveSection(section.id)}
                                    className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${activeSection === section.id
                                        ? 'bg-sage-100 text-sage-700'
                                        : 'text-gray-600 hover:text-sage-600 hover:bg-gray-100'
                                        }`}
                                >
                                    <span className="mr-2">{section.icon}</span>
                                    {section.name}
                                </button>
                            ))}
                        </div>
                    </div>

                    <div className="flex items-center space-x-4">
                        <span className="text-sm text-gray-600">
                            Welcome, {user?.email}
                        </span>
                        <Link
                            to="/"
                            className="bg-gray-600 text-white px-4 py-2 rounded-lg hover:bg-gray-700 transition-colors text-sm"
                        >
                            View Site
                        </Link>
                        <button
                            onClick={onLogout}
                            className="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 transition-colors text-sm"
                        >
                            Logout
                        </button>
                    </div>
                </div>

                {/* Mobile Navigation */}
                <div className="md:hidden pb-4">
                    <div className="grid grid-cols-2 gap-2">
                        {sections.map((section) => (
                            <button
                                key={section.id}
                                onClick={() => setActiveSection(section.id)}
                                className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors ${activeSection === section.id
                                    ? 'bg-sage-100 text-sage-700'
                                    : 'text-gray-600 hover:text-sage-600 hover:bg-gray-100'
                                    }`}
                            >
                                <span className="mr-2">{section.icon}</span>
                                {section.name}
                            </button>
                        ))}
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default AdminNavbar;